import React from "react";
import { useQuery } from "react-query";
import { getUserData } from "../../services/dashboardapi";
import Loading from "../Loadings/LoadingTable";
import { SummeryCard } from "../SummaryCard/SummeryCard";
import People from "../../assets/images/people.svg";
import onlineSell from "../../assets/images/onlineSell.svg";
import currentSell from "../../assets/images/currentSell.svg";
import failedSell from "../../assets/images/failedSell.svg";
import customers from "../../assets/images/customers.svg";
import clue from "../../assets/images/clue.svg";
import vipCustomer from "../../assets/images/vipCustomer.svg";
import todayUser from "../../assets/images/todayUser.svg";
import todayCustomer from "../../assets/images/todayCustomer.svg";
import todayClue from "../../assets/images/todayClue.svg";
import todayProduct from "../../assets/images/todayProduct.svg";
import todayActiveProduct from "../../assets/images/todayActiveProduct.svg";
import soldoutActiveProduct from "../../assets/images/soldoutActiveProduct.svg";
import stagnantProduct from "../../assets/images/stagnantProduct.svg";
const ManagementDashboardApp = ({
  pathName1_1,
  pathName1_2,
  pathName1_3,
  pathName1_4,
  pathName2_1,
  pathName2_2,
  pathName2_3,
  pathName2_4,
  pathName3_1,
  pathName3_2,
  pathName3_3,
  pathName3_4,
  pathName4_1,
  pathName4_2,
  pathName4_3,
  pathName4_4,
}) => {
  const { data, isLoading } = useQuery("userdata", getUserData);

  const info = data?.data;
  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="row">
      <div className="col-lg-3">
        <SummeryCard
          title={"فروش"}
          Amount={parseInt(info?.AllSumOrder).toLocaleString()}
          pathname={"/dashboard/accounting/orders"}
          bgColor={"#009ef7"}
          subtitle={"فرو کل"}
          onlineOrderTitle={"فروش حضوری"}
          offlineOrderTitle={"فروش آنلاین"}
          invoiceOrderTitle={"فروش جاری"}
          unsuccessfullTitle={"فروش ناموفق"}
          onlineOrder={parseInt(info?.OrderOfflines).toLocaleString()}
          offlineOrder={parseInt(info?.OrderOnlines).toLocaleString()}
          invoiceOrder={parseInt(info?.InvoiceOrder).toLocaleString()}
          unsuccessfull={parseInt(info?.OrderUnSuccessful).toLocaleString()}
          row1Icon={
            <img
              style={{ margin: "0 auto" }}
              src={People}
              className="img-fluid"
            />
          }
          row2Icon={
            <img
              style={{ margin: "0 auto" }}
              src={onlineSell}
              className="img-fluid"
            />
          }
          row3Icon={
            <img
              style={{ margin: "0 auto" }}
              src={currentSell}
              className="img-fluid"
            />
          }
          row4Icon={
            <img
              style={{ margin: "0 auto" }}
              src={failedSell}
              className="img-fluid"
            />
          }
          pathName1={pathName1_1}
          pathName2={pathName1_2}
          pathName3={pathName1_3}
          pathName4={pathName1_4}
        />
      </div>
      <div className="col-lg-3">
        <SummeryCard
          title={"مشتری و سرنخ"}
          Amount={(info?.AllSlesOpportunities).toLocaleString()}
          pathname={"/dashboard/accounting/orders"}
          bgColor={"#f1416c"}
          subtitle={"مجموع مشتری و سرنخ"}
          onlineOrderTitle={"مشتریان"}
          offlineOrderTitle={"سرنخ ها"}
          invoiceOrderTitle={"مشتریان vip"}
          //   unsuccessfullTitle={"فروش ناموفق"}
          onlineOrder={(info?.AllCustomerSles_Opportunities).toLocaleString()}
          offlineOrder={(info?.AllClueSles_Opportunities).toLocaleString()}
          invoiceOrder={(info?.VIPSalesOpportunities).toLocaleString()}
          //   unsuccessfull={}
          row1Icon={
            <img
              style={{ margin: "0 auto" }}
              src={customers}
              className="img-fluid"
            />
          }
          row2Icon={
            <img
              style={{ margin: "0 auto" }}
              src={clue}
              className="img-fluid"
            />
          }
          row3Icon={
            <img
              style={{ margin: "0 auto" }}
              src={vipCustomer}
              className="img-fluid"
            />
          }
          pathName1={pathName2_1}
          pathName2={pathName2_2}
          pathName3={pathName2_3}
          pathName4={pathName2_4}
        />
      </div>
      <div className="col-lg-3">
        <SummeryCard
          title={"کاربران"}
          Amount={(info?.AllUsers).toLocaleString()}
          pathname={"/dashboard/accounting/orders"}
          bgColor={"#50cd89"}
          subtitle={"کل کاربران"}
          onlineOrderTitle={"کاربران امروز"}
          offlineOrderTitle={"مشتریان امروز"}
          invoiceOrderTitle={"سرنخ های امروز"}
          // unsuccessfullTitle={""}
          onlineOrder={(info?.TodayUsers).toLocaleString()}
          offlineOrder={(info?.TodayCustomerSles_Opportunities).toLocaleString()}
          invoiceOrder={(info?.TodayClueSles_Opportunities).toLocaleString()}
          //   unsuccessfull={}
          row1Icon={
            <img
              style={{ margin: "0 auto" }}
              src={todayUser}
              className="img-fluid"
            />
          }
          row2Icon={
            <img
              style={{ margin: "0 auto" }}
              src={todayCustomer}
              className="img-fluid"
            />
          }
          row3Icon={
            <img
              style={{ margin: "0 auto" }}
              src={todayClue}
              className="img-fluid"
            />
          }
          pathName1={pathName3_1}
          pathName2={pathName3_2}
          pathName3={pathName3_3}
          pathName4={pathName3_4}
        />
      </div>
      <div className="col-lg-3">
        <SummeryCard
          title={"محصولات"}
          Amount={(info?.AllProducts).toLocaleString()}
          pathname={"/dashboard/accounting/orders"}
          bgColor={"#009ef7"}
          subtitle={"کل محصولات"}
          onlineOrderTitle={"محصولات امروز"}
          offlineOrderTitle={"محصولات فعال موجود"}
          invoiceOrderTitle={"محصولات فعال ناموجود"}
          unsuccessfullTitle={"محصولات راکد"}
          onlineOrder={(info?.TodayProducts).toLocaleString()}
          offlineOrder={(info?.ActiveProductsAvailable).toLocaleString()}
          invoiceOrder={(info?.ActiveProductsNotAvailable).toLocaleString()}
          unsuccessfull={(info?.StagnantProducts).toLocaleString()}
          row1Icon={
            <img
              style={{ margin: "0 auto" }}
              src={todayProduct}
              className="img-fluid"
            />
          }
          row2Icon={
            <img
              style={{ margin: "0 auto" }}
              src={todayActiveProduct}
              className="img-fluid"
            />
          }
          row3Icon={
            <img
              style={{ margin: "0 auto" }}
              src={soldoutActiveProduct}
              className="img-fluid"
            />
          }
          row4Icon={
            <img
              style={{ margin: "0 auto" }}
              src={stagnantProduct}
              className="img-fluid"
            />
          }
          pathName1={pathName4_1}
          pathName2={pathName4_2}
          pathName3={pathName4_3}
          pathName4={pathName4_4}
        />
      </div>
    </div>
  );
};

export default ManagementDashboardApp;
